import { useMutation } from '@tanstack/react-query';

import { fetchListOneHistoryLogsApi } from '../api';

export default function useListOneLogsMutation(options?: any) {
  return useMutation(fetchListOneHistoryLogsApi, options);
}
